import { render } from "./Penitenziali.vue?vue&type=template&id=9433ced2"
import script from "./Penitenziali.vue?vue&type=script&lang=js"
export * from "./Penitenziali.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__